import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../utils/utils.service';

@Pipe({
	name: 'toCamel',
	standalone: true
})
export class ToCamelPipe implements PipeTransform {
	transform(value: string): string {
		return UtilsService.toCamel(value);
	}
}
